export default __webpack_public_path__ + "static/media/Montserrat-LightItalic.89c11580.ttf";